import { render, staticRenderFns } from "./payment.vue?vue&type=template&id=4b106bb6&scoped=true"
import script from "./payment.vue?vue&type=script&lang=js"
export * from "./payment.vue?vue&type=script&lang=js"
import style0 from "./payment.vue?vue&type=style&index=0&id=4b106bb6&prod&scoped=true&lang=css"
import style1 from "./payment.vue?vue&type=style&index=1&id=4b106bb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b106bb6",
  null
  
)

export default component.exports